import React, { useState, useEffect } from "react";
import Modal from "@components/Modal";
import { Form, DatePicker, InputNumber, Table } from "antd";
import Title from "@/components/Title";
import Area from "@/components/twoarea";
import Analysisapi from "@/api/analysis";
import moment from "moment";
import ExportData from "../../../../components/ExportData";
import "../style.css";

const { RangePicker } = DatePicker;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 15 },
};

export default ({ history }) => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [visible, setVisible] = useState(false);
  const [twovisible, setTwoVisible] = useState(false);
  const [station, setStation] = useState([]);
  const [cname, setCname] = useState("");
  const [dataId, setDataID] = useState();
  const [stationId, setStationId] = useState();
  const [dateArr, setDateArr] = useState([moment().startOf("month"), moment()]);
  const [searchParams, setSearchParams] = useState({
    queryTimeStartStr:
      moment().startOf("month").format("YYYY-MM-DD ") + "00:00:00",
    queryTimeEndStr: moment().format("YYYY-MM-DD ") + "23:59:59",
    reportType: 1,
    stationId: stationId,
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (stationId) {
      ListByPage();
    }
    return () => {};
  }, [searchParams]);

  useEffect(() => {
    getStation();
  }, []);

  const ListByPage = () => {
    setLoading(true);
    Analysisapi.listQualityByPage({ ...searchParams }).then((res) => {
      setLoading(false);
      if (res.status == 0 && res.data) {
        let arr = [];
        res.data.tableHead.map((item) => {
          arr.push({
            title: item,
            dataIndex: item,
            align: "center",
            key: item,
          });
        });
        arr.unshift({
          title: "时间",
          align: "center",
          dataIndex: "createTime",
          key: "createTime",
        });
        let newdata = res.data.tableData.map((item, index) => {
          item.jsonVal["id"] = item.id;
          item.jsonVal["createTime"] = item.createTime;
          for (let i in item.jsonVal) {
            if (item.jsonVal[i].toString().indexOf(".") != -1) {
              if (item.jsonVal[i].toString().split(".")[1].length > 2) {
                item.jsonVal[i] = item.jsonVal[i].toFixed(2);
              }
            }
          }
          return item.jsonVal;
        });
        setData(newdata);
        if (arr.length > 0) {
        }
        setColumns(arr);
      }
    });
  };
  const getStation = () => {
    Analysisapi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        const id = res.data[0] ? res.data[0].id : -1;
        setStationId(id);
        setStation(res.data);
        setSearchParams({ ...searchParams, stationId: id });
      }
    });
  };
  const dateQuery = (values) => {
    setDateArr(values);
    setSearchParams({
      ...searchParams,
      queryTimeStartStr: values[0].format("YYYY-MM-DD ") + "00:00:00",
      queryTimeEndStr: values[1].format("YYYY-MM-DD ") + "23:59:59",
    });
  };
  const getStationId = (id) => {
    setSearchParams({
      ...searchParams,
      stationId: id,
    });
    setStationId(id);
  };
  const showBox = (obj) => {
    form.setFieldsValue({
      ...obj,
    });
    setVisible(true); //设置对话框可见
    const newCname = obj.stationName;
    setCname(newCname);
    setDataID(obj.id);
  };
  const cancel = () => {
    form.resetFields();
    setVisible(false);
  };

  const submit = () => {
    form.validateFields().then((values) => {
      Analysisapi.updateData({ jsonVal: values, id: dataId }).then((res) => {
        if (res.status == 0) {
          ListByPage();
          setVisible(false);
        }
      });
    });
  };

  return (
    <div className="out basecontent">
      <Title title="水质报表"></Title>
      <span className="daochu" onClick={() => setTwoVisible(true)}>
        <i className="iconfont iconxiazaimoban"></i>
        &nbsp;导出
      </span>
      <span className="solid"></span>
      <span className="year">
        <span>日期:&nbsp;</span>
        <RangePicker value={dateArr} allowClear={false} onChange={dateQuery} />
      </span>
      <span className="area" style={{ width: "50%" }}>
        <span
          style={{
            position: "absolute",
            marginLeft: "18px",
            borderBottom: "1px solid #EEF0F3",
            padding: "11px 15px 12px 5px",
            zIndex: "999",
          }}
        >
          厂站:
        </span>
        <Area station={station} getStationId={getStationId} />
      </span>
      <Table
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={data}
        scroll={{ y: 600 }}
        pagination={false}
        loading={loading}
        className="table"
      />

      {visible && (
        <Modal
          title="编辑"
          visible={visible}
          cname={cname}
          onCancel={() => cancel()}
          onSubmit={() => submit()}
        >
          <div>
            <Form
              {...layout}
              form={form}
              layout="horizontal"
              style={{ marginLeft: "20px" }}
            >
              {columns.map((item) => {
                if (item.key != "createTime" && item.key != "operation") {
                  return (
                    <Form.Item
                      key={item.key}
                      label={item.title}
                      name={item.title}
                      rules={[
                        {
                          required: true,
                          pattern: new RegExp(/^\d+(\.\d{1,2})?$/),
                          message: "请填入保留两位小数的数据",
                        },
                      ]}
                    >
                      <InputNumber style={{ color: "#B4BCC4" }} />
                    </Form.Item>
                  );
                }
              })}
            </Form>
          </div>
        </Modal>
      )}
      {twovisible && (
        <ExportData
          visible={twovisible}
          reportType={1}
          close={() => setTwoVisible(false)}
          exportFileName="水质报表"
        />
      )}
    </div>
  );
};
